import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const FlowDownstreamWorkbooksQueryGql: DocumentNode = gql`
query FlowDownstreamWorkbooksQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragment
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
